/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Per_MonthInputs */

const tr_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ay`)
};

const en_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/month`)
};

const de_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/Monat`)
};

const ru_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/мес.`)
};

/**
* | output |
* | --- |
* | "/month" |
*
* @param {Pricing_Per_MonthInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_per_month = /** @type {((inputs?: Pricing_Per_MonthInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Per_MonthInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_per_month(inputs)
	if (locale === "de") return de_pricing_per_month(inputs)
	if (locale === "ru") return ru_pricing_per_month(inputs)
	return tr_pricing_per_month(inputs)
});